import { render, staticRenderFns } from "./terminalCompanypriceAction.vue?vue&type=template&id=0998f1ab&scoped=true"
import script from "./terminalCompanypriceAction.vue?vue&type=script&lang=js"
export * from "./terminalCompanypriceAction.vue?vue&type=script&lang=js"
import style0 from "./terminalCompanypriceAction.vue?vue&type=style&index=0&id=0998f1ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0998f1ab",
  null
  
)

export default component.exports